import { Controllers } from 'lib/enums/routes/_controllers';
import { PricesRoutes } from 'lib/enums/routes/prices';
import { PriceDoc, PriceWhole } from 'lib/interfaces/database/price';
import { BaseService } from 'services/_base';

export class PricesService extends BaseService {
  private static instance: PricesService;

  static getInstance(): PricesService {
    if (!PricesService.instance) {
      PricesService.instance = new PricesService();
    }

    return PricesService.instance;
  }

  private constructor() {
    super({
      controller: Controllers.prices,
    });
  }

  search(payload: Partial<PriceDoc>) {
    return this.POST(
      {
        uri: PricesRoutes.Search,
      },
      payload
    )
      .then((result: PriceWhole[]) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  create(payload: Partial<PriceDoc>) {
    return this.POST(
      {
        uri: PricesRoutes.CreateOne,
      },
      payload
    )
      .then((result: PriceWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  update(id: string, payload: Partial<PriceDoc>) {
    return this.PUT(
      {
        uri: `${PricesRoutes.UpdateOne}/${id}`,
      },
      payload
    )
      .then((result: PriceWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  delete(id: string) {
    return this.DELETE({
      uri: `${PricesRoutes.DeleteOne}/${id}`,
    })
      .then((success: boolean) => {
        return success;
      })
      .catch((error) => {
        console.error(error);
        return false;
      });
  }
}
